var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "frankinForm__letters",
        class: { inputPanel__error: _vm.class1_letters_validation }
      },
      [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "inputPanel inputPanel--tight" }, [
          _vm._m(2),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "inputPanel__col inputPanel__input inputPanel__input--groupFull"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.class1_standard_letters,
                    expression: "class1_standard_letters"
                  },
                  {
                    name: "positive-numbers-only",
                    rawName: "v-positive-numbers-only"
                  }
                ],
                staticClass: "inputReg",
                attrs: {
                  type: "number",
                  name: "1stclassstandard",
                  id: "1stclassstandard",
                  placeholder: "Enter Value"
                },
                domProps: { value: _vm.class1_standard_letters },
                on: {
                  keyup: function($event) {
                    return _vm.checkValidation()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.class1_standard_letters = $event.target.value
                  }
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inputPanel inputPanel--tight" }, [
          _vm._m(3),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "inputPanel__col inputPanel__input inputPanel__input--groupFull"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.class1_large_100_letters,
                    expression: "class1_large_100_letters"
                  },
                  {
                    name: "positive-numbers-only",
                    rawName: "v-positive-numbers-only"
                  }
                ],
                staticClass: "inputReg",
                attrs: {
                  type: "number",
                  name: "100g1st",
                  id: "100g1st",
                  placeholder: "Enter Value"
                },
                domProps: { value: _vm.class1_large_100_letters },
                on: {
                  keyup: function($event) {
                    return _vm.checkValidation()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.class1_large_100_letters = $event.target.value
                  }
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inputPanel inputPanel--tight" }, [
          _vm._m(4),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "inputPanel__col inputPanel__input inputPanel__input--groupFull"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.class1_large_100_250_letters,
                    expression: "class1_large_100_250_letters"
                  },
                  {
                    name: "positive-numbers-only",
                    rawName: "v-positive-numbers-only"
                  }
                ],
                staticClass: "inputReg",
                attrs: {
                  type: "number",
                  name: "100250g1st",
                  id: "100250g1st",
                  placeholder: "Enter Value"
                },
                domProps: { value: _vm.class1_large_100_250_letters },
                on: {
                  keyup: function($event) {
                    return _vm.checkValidation()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.class1_large_100_250_letters = $event.target.value
                  }
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inputPanel inputPanel--tight" }, [
          _vm._m(5),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "inputPanel__col inputPanel__input inputPanel__input--groupFull"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.class1_large_250_500_letters,
                    expression: "class1_large_250_500_letters"
                  },
                  {
                    name: "positive-numbers-only",
                    rawName: "v-positive-numbers-only"
                  }
                ],
                staticClass: "inputReg",
                attrs: {
                  type: "number",
                  name: "250500g1st",
                  id: "250500g1st",
                  placeholder: "Enter Value"
                },
                domProps: { value: _vm.class1_large_250_500_letters },
                on: {
                  keyup: function($event) {
                    return _vm.checkValidation()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.class1_large_250_500_letters = $event.target.value
                  }
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inputPanel inputPanel--tight" }, [
          _vm._m(6),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "inputPanel__col inputPanel__input inputPanel__input--groupFull"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.class1_large_500_750_letters,
                    expression: "class1_large_500_750_letters"
                  },
                  {
                    name: "positive-numbers-only",
                    rawName: "v-positive-numbers-only"
                  }
                ],
                staticClass: "inputReg",
                attrs: {
                  type: "number",
                  name: "500700g1st",
                  id: "500700g1st",
                  placeholder: "Enter Value"
                },
                domProps: { value: _vm.class1_large_500_750_letters },
                on: {
                  keyup: function($event) {
                    return _vm.checkValidation()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.class1_large_500_750_letters = $event.target.value
                  }
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("error-modal", [
          _vm._v(
            "\n      Please see our guide HERE on how to pull this breadkdown from the Pitney Bowes or Quadient (Neopost) web portal.\n      "
          ),
          _c("br"),
          _vm._v("\n      Frama does not offer this level of detail.\n      "),
          _c("br"),
          _vm._v(
            "\n      FP does not offer this level of detail unless you are using Navigator plus on your FP machine.\n      "
          ),
          _c("br"),
          _vm._v(
            "\n      If you do not have this detail and would like to proceed with your quote based on you estimated typical volumes please proceed, or you can utilise our infromation gathering service. This service allows us on your consent to gather all necessary information and detail on your behalf. "
          ),
          _c(
            "a",
            {
              attrs: {
                href: "https://themailingexpert.com/let-us-do-it-for-you/",
                target: "_blank"
              }
            },
            [_vm._v("Click here")]
          ),
          _vm._v(
            " to understand more and to request this free service.**\n    "
          )
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "frankinForm__letters",
        class: { inputPanel__error: _vm.class2_letters_validation }
      },
      [
        _vm._m(7),
        _vm._v(" "),
        _c("div", { staticClass: "inputPanel inputPanel--tight" }, [
          _vm._m(8),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "inputPanel__col inputPanel__input inputPanel__input--groupFull"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.class2_standard_letters,
                    expression: "class2_standard_letters"
                  },
                  {
                    name: "positive-numbers-only",
                    rawName: "v-positive-numbers-only"
                  }
                ],
                staticClass: "inputReg",
                attrs: {
                  type: "number",
                  name: "dlorc5",
                  id: "dlorc5",
                  placeholder: "Enter Value"
                },
                domProps: { value: _vm.class2_standard_letters },
                on: {
                  keyup: function($event) {
                    return _vm.checkValidation()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.class2_standard_letters = $event.target.value
                  }
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inputPanel inputPanel--tight" }, [
          _vm._m(9),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "inputPanel__col inputPanel__input inputPanel__input--groupFull"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.class2_large_100_letters,
                    expression: "class2_large_100_letters"
                  },
                  {
                    name: "positive-numbers-only",
                    rawName: "v-positive-numbers-only"
                  }
                ],
                staticClass: "inputReg",
                attrs: {
                  type: "number",
                  name: "100g2nd",
                  id: "100g2nd",
                  placeholder: "Enter Value"
                },
                domProps: { value: _vm.class2_large_100_letters },
                on: {
                  keyup: function($event) {
                    return _vm.checkValidation()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.class2_large_100_letters = $event.target.value
                  }
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inputPanel inputPanel--tight" }, [
          _vm._m(10),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "inputPanel__col inputPanel__input inputPanel__input--groupFull"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.class2_large_100_250_letters,
                    expression: "class2_large_100_250_letters"
                  },
                  {
                    name: "positive-numbers-only",
                    rawName: "v-positive-numbers-only"
                  }
                ],
                staticClass: "inputReg",
                attrs: {
                  type: "number",
                  name: "100250g",
                  id: "100250g",
                  placeholder: "Enter Value"
                },
                domProps: { value: _vm.class2_large_100_250_letters },
                on: {
                  keyup: function($event) {
                    return _vm.checkValidation()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.class2_large_100_250_letters = $event.target.value
                  }
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inputPanel inputPanel--tight" }, [
          _vm._m(11),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "inputPanel__col inputPanel__input inputPanel__input--groupFull"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.class2_large_250_500_letters,
                    expression: "class2_large_250_500_letters"
                  },
                  {
                    name: "positive-numbers-only",
                    rawName: "v-positive-numbers-only"
                  }
                ],
                staticClass: "inputReg",
                attrs: {
                  type: "number",
                  name: "250500g",
                  id: "250500g",
                  placeholder: "Enter Value"
                },
                domProps: { value: _vm.class2_large_250_500_letters },
                on: {
                  keyup: function($event) {
                    return _vm.checkValidation()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.class2_large_250_500_letters = $event.target.value
                  }
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inputPanel inputPanel--tight" }, [
          _vm._m(12),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "inputPanel__col inputPanel__input inputPanel__input--groupFull"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.class2_large_500_750_letters,
                    expression: "class2_large_500_750_letters"
                  },
                  {
                    name: "positive-numbers-only",
                    rawName: "v-positive-numbers-only"
                  }
                ],
                staticClass: "inputReg",
                attrs: {
                  type: "number",
                  name: "500700g",
                  id: "500700g",
                  placeholder: "Enter Value"
                },
                domProps: { value: _vm.class2_large_500_750_letters },
                on: {
                  keyup: function($event) {
                    return _vm.checkValidation()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.class2_large_500_750_letters = $event.target.value
                  }
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("error-modal", [
          _vm._v(
            "\n      Please see our guide HERE on how to pull this breadkdown from the Pitney Bowes or Quadient (Neopost) web portal.\n      "
          ),
          _c("br"),
          _vm._v("\n      Frama does not offer this level of detail.\n      "),
          _c("br"),
          _vm._v(
            "\n      FP does not offer this level of detail unless you are using Navigator plus on your FP machine.\n      "
          ),
          _c("br"),
          _vm._v(
            "\n      If you do not have this detail and would like to proceed with your quote based on you estimated typical volumes please proceed, or you can utilise our infromation gathering service. This service allows us on your consent to gather all necessary information and detail on your behalf. "
          ),
          _c(
            "a",
            {
              attrs: {
                href: "https://themailingexpert.com/let-us-do-it-for-you/",
                target: "_blank"
              }
            },
            [_vm._v("Click here")]
          ),
          _vm._v(
            " to understand more and to request this free service.**\n    "
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputPanel" }, [
      _c("div", { staticClass: "inputPanel__col inputPanel__question" }, [
        _c("label", { staticStyle: { "font-weight": "500" } }, [
          _vm._v(
            "\n        Please confirm number of items per class and format for accurate additional savings calculation.\n      "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "imagePanel" }, [
      _c("img", {
        attrs: {
          src: require("../../../../../../static/styles/mailkit/img/stamp.jpg"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "inputPanel__col inputPanel__question inputPanel__question--bordered"
      },
      [_c("label", [_vm._v("1st Class Standard Letters i.e. DL or C5 ")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "inputPanel__col inputPanel__question inputPanel__question--bordered"
      },
      [_c("label", [_vm._v("1st Class Large Letters up to 100g ")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "inputPanel__col inputPanel__question inputPanel__question--bordered"
      },
      [_c("label", [_vm._v("1st Class Large Letters up to 100g - 250g ")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "inputPanel__col inputPanel__question inputPanel__question--bordered"
      },
      [_c("label", [_vm._v("1st Class Large Letters between 250g - 500g ")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "inputPanel__col inputPanel__question inputPanel__question--bordered"
      },
      [_c("label", [_vm._v("1st Class Large Letters between 500g - 750g")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "imagePanel" }, [
      _c("img", {
        attrs: {
          src: require("../../../../../../static/styles/mailkit/img/stamp2.jpg"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "inputPanel__col inputPanel__question inputPanel__question--bordered"
      },
      [_c("label", [_vm._v("2nd Class Standard Letters i.e. DL or C5 ")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "inputPanel__col inputPanel__question inputPanel__question--bordered"
      },
      [_c("label", [_vm._v("2nd Class Large Letters up to 100g ")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "inputPanel__col inputPanel__question inputPanel__question--bordered"
      },
      [_c("label", [_vm._v("2nd Class Large Letters up to 100g - 250g ")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "inputPanel__col inputPanel__question inputPanel__question--bordered"
      },
      [_c("label", [_vm._v("2nd Class Large Letters between 250g - 500g ")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "inputPanel__col inputPanel__question inputPanel__question--bordered"
      },
      [_c("label", [_vm._v("2nd Class Large Letters between 500g - 750g ")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7db1c3ef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7db1c3ef","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Quotes/Form/Step-2/Conditionals/Form_FrankingFormLetters.vue
// module id = null
// module chunks = 